import GetEnumData from "./helpers";

let enumsDifficulty = {
    easy : { Label: "Simple" },
    normal : { Label: "Normal" },
    hard : { Label: "Difficile" },
}

let Difficulty = {
	label: (label) => {
		return GetEnumData(enumsDifficulty, label).Label;
	}
};

export default Difficulty;